/* Katsu VSL landing page — video players + testimonial carousel.
   Every section initialises itself, and re-initialises when edited in the theme editor. */
(function () {
  'use strict';

  var allVideos = function () { return document.querySelectorAll('.lt-katsu-vsl video'); };
  function pauseAll(except) {
    Array.prototype.forEach.call(allVideos(), function (v) { if (v !== except && !v.paused) v.pause(); });
  }

  /* ---------- Video players ---------- */
  function initPlayer(p) {
    if (p.__ltkv) return; p.__ltkv = true;
    var v = p.querySelector('video');
    if (!v) return;
    v.addEventListener('loadedmetadata', function () {
      
      if (!v.poster && v.currentTime === 0) { try { v.currentTime = 0.1; } catch (e) {} }
    }, { once: true });
    var src = v.querySelector('source');
    (src || v).addEventListener('error', function () {
      if (p.querySelector('.lt-kv-vplayer__err')) return;
      var m = document.createElement('p'); m.className = 'lt-kv-vplayer__err';
      m.textContent = 'This video could not be loaded.';
      p.appendChild(m);
    });
    p.addEventListener('click', function () {
      var card = p.closest('.lt-kv-t-card');
      if (card && !card.classList.contains('lt-kv-is-active')) return;
      if (v.paused) { pauseAll(v); v.controls = true; v.play(); v.muted = false; }
    });
    v.addEventListener('play', function () { p.classList.add('lt-kv-is-playing'); pauseAll(v); });
    v.addEventListener('pause', function () { if (!v.seeking) p.classList.remove('lt-kv-is-playing'); });
    v.addEventListener('ended', function () { p.classList.remove('lt-kv-is-playing'); v.controls = false; });
  }

  /* ---------- Lazy video sources (data-src) ---------- */
  function hydrate(scope) {
    Array.prototype.forEach.call(scope.querySelectorAll('source[data-src]'), function (s) {
      if (s.getAttribute('src')) return;
      s.setAttribute('src', s.getAttribute('data-src'));
      var v = s.parentNode; v.preload = 'metadata'; v.load();
    });
  }
  function lazyVideos(scope) {
    if (!scope.querySelector('source[data-src]')) return;
    if (!('IntersectionObserver' in window)) return hydrate(scope);
    var io = new IntersectionObserver(function (es) {
      if (es.some(function (e) { return e.isIntersecting; })) { hydrate(scope); io.disconnect(); }
    }, { rootMargin: '400px 0px' });
    io.observe(scope);
  }

  /* ---------- Testimonial carousel ---------- */
  function initCarousel(root) {
    var track = root.querySelector('[data-lt-kv-track]');
    if (!track || track.__ltkv) return; track.__ltkv = true;
    var cards = Array.prototype.slice.call(track.children);
    if (!cards.length) return;
    var dots = root.querySelector('[data-lt-kv-dots]');
    var index = 0;
    dots.innerHTML = '';
    cards.forEach(function (c, i) {
      var b = document.createElement('button');
      b.type = 'button'; b.setAttribute('aria-label', 'Go to testimonial ' + (i + 1));
      b.addEventListener('click', function () { go(i); });
      dots.appendChild(b);
      c.addEventListener('click', function () { if (i !== index) go(i); });
    });
    function layout() {
      var card = cards[index];
      var vw = track.parentElement.clientWidth;
      var offset = card.offsetLeft + card.offsetWidth / 2 - vw / 2;
      track.style.transform = 'translateX(' + (-offset) + 'px)';
    }
    function go(i) {
      index = (i + cards.length) % cards.length;
      pauseAll(null);
      cards.forEach(function (c, j) {
        c.classList.toggle('lt-kv-is-active', j === index);
        c.setAttribute('aria-hidden', j === index ? 'false' : 'true');
        var v = c.querySelector('video'); if (v && j !== index) v.controls = false;
      });
      Array.prototype.forEach.call(dots.children, function (d, j) { d.classList.toggle('lt-kv-is-active', j === index); });
      layout();
      schedule();
    }

    /* ---------- Autoplay ----------
       Advances every N seconds and loops back to the first card after the last.
       Holds (any one of them stops the timer): a video playing, mouse hover,
       keyboard focus, tab hidden, section off-screen, theme-editor block selected. */
    var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var autoplay = root.getAttribute('data-autoplay') === 'true' && cards.length > 1 && !reduceMotion;
    var delay = Math.max(parseFloat(root.getAttribute('data-autoplay-speed')) || 6, 2) * 1000;
    var timer = null;
    var holds = { offscreen: 'IntersectionObserver' in window };

    function held() { for (var k in holds) { if (holds[k]) return true; } return false; }
    function schedule() {
      clearTimeout(timer); timer = null;
      if (!autoplay || held()) return;
      timer = setTimeout(function () {
        if (!root.isConnected) return; // section was re-rendered in the editor
        go(index + 1);
      }, delay);
    }
    function hold(key, on) { holds[key] = on; schedule(); }

    if (autoplay) {
      // Media events don't bubble, so listen in the capture phase.
      track.addEventListener('play', function () { hold('video', true); }, true);
      track.addEventListener('pause', function () { hold('video', false); }, true);
      track.addEventListener('ended', function () { hold('video', false); }, true);

      // Mouse only — touch "hover" would otherwise stick after a tap.
      root.addEventListener('pointerenter', function (e) { if (e.pointerType === 'mouse') hold('hover', true); });
      root.addEventListener('pointerleave', function (e) { if (e.pointerType === 'mouse') hold('hover', false); });

      root.addEventListener('focusin', function () { hold('focus', true); });
      root.addEventListener('focusout', function (e) { if (!root.contains(e.relatedTarget)) hold('focus', false); });

      var onVisibility = function () {
        if (!root.isConnected) { document.removeEventListener('visibilitychange', onVisibility); return; }
        hold('hidden', document.hidden);
      };
      document.addEventListener('visibilitychange', onVisibility);

      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (es) { hold('offscreen', !es[0].isIntersecting); }, { threshold: 0.25 }).observe(root);
      }
    }
    root.__ltkvHold = function (key, on) { hold(key, on); };
    var prev = root.querySelector('[data-lt-kv-prev]'), next = root.querySelector('[data-lt-kv-next]');
    if (prev) prev.addEventListener('click', function () { go(index - 1); });
    if (next) next.addEventListener('click', function () { go(index + 1); });
    window.addEventListener('resize', layout);
    var sx = null;
    track.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; }, { passive: true });
    track.addEventListener('touchend', function (e) {
      if (sx === null) return;
      var dx = e.changedTouches[0].clientX - sx;
      if (Math.abs(dx) > 40) go(index + (dx < 0 ? 1 : -1));
      sx = null;
    });
    root.__ltkvGo = function (el) { var i = cards.indexOf(el); if (i > -1) go(i); };
    var start = parseInt(track.getAttribute('data-start') || '1', 10) - 1;
    go(Math.min(Math.max(start, 0), cards.length - 1));
  }

  function init(scope) {
    Array.prototype.forEach.call(scope.querySelectorAll('[data-lt-kv-player]'), initPlayer);
    Array.prototype.forEach.call(scope.querySelectorAll('[data-lt-kv-carousel]'), function (c) { initCarousel(c); lazyVideos(c); });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);

  /* ---------- Theme editor ---------- */
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  document.addEventListener('shopify:block:select', function (e) {
    var root = e.target.closest('[data-lt-kv-carousel]');
    if (!root) return;
    if (root.__ltkvHold) root.__ltkvHold('editor', true);
    if (root.__ltkvGo) root.__ltkvGo(e.target.closest('.lt-kv-t-card'));
  });
  document.addEventListener('shopify:block:deselect', function (e) {
    var root = e.target.closest('[data-lt-kv-carousel]');
    if (root && root.__ltkvHold) root.__ltkvHold('editor', false);
  });
})();